"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCorrectShade = void 0;
/**
 * Checks if `shade` is key of `colorObject`.
 * @param colorObject Is subobject of `theme.palette` object.
 * @param shade Is possible key of `colorObject`.
 * @returns True if `shade` is key of `colorObject`.
 */
const isCorrectShade = (colorObject, shade) => Object.keys(colorObject).includes(shade);
exports.isCorrectShade = isCorrectShade;
